import { emailer } from "../../../assets/images";
import { Card, Row, Tooltip } from "antd";
import { DAYS, MONTHS } from "../../../constants/companyMailer";
import { useEffect, useState } from "react";
import {
  dsButtonDisabledTextAction,
  dsButtonGhostBrand,
  dsButtonSecondary,
  dsButtonTextAction,
  joinButtonClasses,
} from "../../../utils/buttonStyles";

const MailerCard = ({
  mailerData,
  onEdit,
  onSendNow,
  onSendTestMail,
  onPreview,
  pageloading,
  onClone
}) => {

  const [groupedMailerData, setGroupedMailerData] = useState([]);

  useEffect(() => {
    if (mailerData?.length) {
      const grouped = structureMailerData(mailerData);
      setGroupedMailerData(grouped);
    }
  }, [mailerData]);

  const getStatusColor = (status) => {
    switch (status) {
      case "draft":       // blue tone
        return { background: '#EFF6FF', color: '#2563EB' };
      case "scheduled":   // also blue tone
        return { background: '#FFF9E6', color: '#B45309' };
      case "sent":        // green tone
        return { background: '#ECFDF5', color: '#14866D' };
      default:            // gray fallback
        return { background: '#F3F4F6', color: '#6B7280' }; // tailwind: bg-slate-100 text-slate-600
    }
  };


  const dateFormat = (val) => {
    if (!val) return '';

    const dateObj = new Date(val);
    const day = DAYS[dateObj.getDay()] || '';
    const date = dateObj.getDate().toString().padStart(2, '0');
    const month = MONTHS[dateObj.getMonth()] || '';
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');

    return `${day}, ${date} ${month} ${year} at ${hours}:${minutes}`;
  };

  const metrics = (data) => {
    if (!data) return null;

    const { count, sent, delivered_stats, open } = calculateStats(data);
    const items = [
      {
        show: data.delivery?.delivered,
        label: 'SENT',
        value: sent,
        suffix: 'Emails',
      },
      {
        show: data.delivery?.delivered,
        label: 'Delivered',
        value: delivered_stats,
        suffix: 'Emails',
      },
      {
        show: data.engagement?.open,
        label: 'Opened Rate',
        value: open,
        suffix: 'Opened',
      },
      {
        show: false,
        label: 'Action',
        value: 0,
        suffix: 'Activated',
      }
    ];

    return (
      <div className='font-semibold float-right flex flex-row'>
        {items.map(({ show, label, value, suffix }) =>
          show && (
            <div key={label} className='px-5 mx-4 text-center'>
              <div className='text-xs uppercase tracking-widest text-gray-600'>{label}</div>
              <div className='text-xl text-gray-900'>{Math.trunc((value / count) * 100)}%</div>
              <div className='font-normal text-xs text-gray-600'>{value} {suffix}</div>
            </div>
          )
        )}
      </div>
    );
  };

  const calculateStats = (data) => {
    const all = [data, ...(data.grade_variants || [])];
    let sent = 0, delivered = 0, open = 0, count = 0;

    all.forEach(({ mail_count = 0, delivery = {}, engagement = {} }) => {
      count += mail_count;
      sent += ['delivered', 'processed', 'bounce', 'deferred'].reduce((sum, key) => sum + (delivery[key] || 0), 0);
      delivered += (delivery.delivered || 0) + (delivery.processed || 0);
      open += (engagement.open || 0) + (engagement.click || 0);
    });

    return { count, sent, delivered_stats: delivered, open };
  };


  const renderMailerCard = (data) => (
        data.map((data, index) => {
          const { id, grade, benefit_name, description, status, sent_at, updated_at, insights, content, schedule_time } = data;
          const isSent = status === "sent" && sent_at;
          const isScheduled = status === "scheduled" && schedule_time;
          const { background, color } = getStatusColor(status);
          const disabledSend = !content;
          return (
              <Card id={index} style={{ minHeight: 230, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
              <Row className='font-semibold text-lg'>{benefit_name}
                  <span style={{background: background, color: color}} className='rounded-xl px-3 py-1 ml-2 font-semibold text-xs'>
                    {status}
                  </span>
              </Row>
              <Row style={{ fontWeight: 400, width: '70%', marginTop: 7}}>
                  {benefit_name} is a short e-mail that creates a buzz among employees about the new benefit they would be receiving.
              </Row>
              { !isSent &&
                <div className='absolute top-6 right-6'>
        
              <button
                  name={`${grade}-${id}`}
                  type='submit'
                  onClick={onEdit}
                  className={joinButtonClasses(dsButtonGhostBrand, 'mx-4 h-10 px-4')}
              >
                  Edit mailer
              </button>
              <Tooltip
                placement='bottomLeft'
                overlayStyle={{maxWidth: '235px'}}
                color={'#0F1115'}
                key='pink'
                title={`${disabledSend ? `Ensure the email content is saved before initiating the ${benefit_name} mailer.` : ''}`}
                align
              >
                {!isScheduled &&
                  <button name={`${grade}-${id}`} type='submit'
                  disabled={disabledSend}
                  className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4', disabledSend && 'cursor-not-allowed')}
                  onClick={onSendNow}>
                    Send now
                </button>}
              </Tooltip>
              </div>}
              <Row style={{background: '#EFF6FF'}} className='my-4 px-3 py-4 rounded border-2'>
                  <div className='float-left flex flex-row'>
                    <img src={emailer} alt='#' style={{height: 46, width: 48}}/>
                    <div className='mx-2'>
                      <div className='font-semibold text-base' style={{color: '#0F1115'}}>Subject : {description}</div>
                      <div className=''><strong className='text-slate-800'>{isSent ? 'Sent' : (isScheduled ? 'Scheduled' : 'Draft')}</strong> {isScheduled ? 'for' :'on'} {isSent ? dateFormat(sent_at) : (isScheduled ? dateFormat(schedule_time) : dateFormat(updated_at))}</div>
                      { !isSent &&
                        <div className='flex items-center'>
                          <button
                            name={`${grade}-${id}`}
                            onClick={onSendTestMail}
                            disabled={disabledSend}
                            className={joinButtonClasses(dsButtonTextAction, disabledSend && dsButtonDisabledTextAction)}
                          >
                            Send Test Mail
                          </button>
                          <div className="bg-zinc-300 rounded mx-2 w-1 h-1 font-semibold" style={{background: '#D9D9D9'}}></div>
                          <button
                            name={`${grade}-${id}`}
                            onClick={onPreview}
                            disabled={disabledSend}
                            className={joinButtonClasses(dsButtonTextAction, disabledSend && dsButtonDisabledTextAction)}
                          >
                            Preview
                          </button>
                        </div>}
                    </div>
                  </div>
                  {isSent && metrics(insights)}
              </Row>
            </Card>
          )
        }
    )
  );

  const structureMailerData = (data) => {
    if (!Array.isArray(data)) return [];
  
    const variants = data.filter(m => m.is_variant);
    const replicas = data.filter(m => m.is_replica);
  
    return variants.map(variant => {
      const relatedReplicas = replicas.filter(rep => rep.company_mailer_id === variant.id);
      return [variant, ...relatedReplicas];
    });
  };
  

  return (
    <>
      {groupedMailerData.map((group, index) => {
        const variant = group[0]; // First item is always the variant
        const replicas = group.slice(1);
        const { id, grade } = variant || {};
        const disabledClone = variant?.status !== 'sent' && !variant?.sent_at;
  
        return (
          <Card
            key={id || index}
            style={{ minHeight: 150, marginTop: 20, background: '#F9FAFB' }}
            loading={pageloading}
            className='overview-card relative'
          >
            <div className=" flex justify-between items-center">
              <h4 className="inline-block px-3 py-1 text-sm font-semibold text-purple-700 bg-purple-50 border border-purple-200 rounded-full">
                Variant {index + 1}
              </h4>
              <div className='justify-end flex mb-4'>
                <Tooltip
                  placement='topLeft'
                  overlayStyle={{ maxWidth: '235px' }}
                  color='#0F1115'
                  title={disabledClone ? 'Ensure the initial mailer has been sent before cloning.' : ''}
                  align
                >
                  <button
                    name={`${grade}-${id}`}
                    type='submit'
                    disabled={disabledClone}
                    className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4', disabledClone && 'cursor-not-allowed')}
                    onClick={() => onClone(variant)}
                  >
                    Clone mailer
                  </button>
                </Tooltip>
              </div>
            </div>
  
            {/* Render Variant Mailer */}
            {renderMailerCard([variant])}
  
            {/* Render Replicas below */}
            {replicas.length > 0 && (
              <div className='mt-4'>
                <h4 className="inline-block px-3 py-1 mt-4 ml-4 text-sm font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded-full">
                  Replicas
                </h4>
                {renderMailerCard(replicas)}
              </div>
            )}
          </Card>
        );
      })}
    </>
  );  
};

export default MailerCard;
